import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { uniq } from 'lodash';

import AddRecipient from 'components/blocks/AddRecipient';
import ListRecipients from 'components/blocks/ListRecipients';
import UploadRecipients from './UploadRecipients';
import RecipientWarning from './RecipientWarning';
import { getVariablePlaceholdersInString } from 'services/file';
import { Row, Col } from 'components/ui';

const Recipients = ({ setIsCsvValid, setTotalRows, activeTemplate }) => {
  const { watch, setValue } = useFormContext();

  const handleUpdateRecipients = data => {
    setValue('recipients', [...data].map(v => ({ key: v[0], value: v[1] })));
  };

  const isMultiMode = watch('isMultiMode');
  const templateId = watch('templateId');
  const recipients = watch('recipients');
  const csvFiles = watch('csvFiles');

  const recipientsMap = new Map(
    recipients.map(object => {
      return [object.key, object.value];
    }),
  );

  const templateVariables = useMemo(() => {
    const { subject = '', template = '' } = activeTemplate || {};
    const subjectVariables = getVariablePlaceholdersInString(subject);
    const contentVariables = getVariablePlaceholdersInString(template);
    return uniq([...subjectVariables, ...contentVariables]) || [];
  }, [templateId]);

  const disableUploadCSV = isMultiMode
    ? false
    : templateId < 1 || recipients?.length;
  const disableRecipientInput =
    templateId < 1 || isMultiMode || csvFiles?.length;

  return (
    <section className="send-mail-form__section recipients">
      <div className={'todo-error'} />
      <h5>Recipients *</h5>
      {!disableRecipientInput && (
        <ListRecipients
          recipients={recipientsMap}
          template={activeTemplate}
          templateVariables={templateVariables}
          onUpdateRecipients={handleUpdateRecipients}
        />
      )}
      <Row gutter={8}>
        {!isMultiMode && (
          <Col span={10}>
            <AddRecipient
              disabled={disableRecipientInput}
              recipients={recipientsMap}
              template={activeTemplate}
              templateVariables={templateVariables}
              onUpdateRecipients={handleUpdateRecipients}
            />
            <RecipientWarning templateVariables={templateVariables} />
          </Col>
        )}
        <Col span={isMultiMode ? 21 : 12}>
          <UploadRecipients
            disabled={disableUploadCSV}
            setIsCsvValid={setIsCsvValid}
            setTotalRows={setTotalRows}
          />
        </Col>
      </Row>
    </section>
  );
};

export default Recipients;
